const preordini = {
    state: {
        list: [],
        selected: {},
        create: false,
        edit: false,
        delete: false,
        filters: {
            status: {
                inserito: true,
                ordinato: true,
                arrivato: true,
                consegnato: false
            }
        },
    },
    mutations: {
        SET_PREORDINI_LIST(state, payload) {
            state.list = payload
        },
        SET_PREORDINI_SELECTED(state, payload) {
            state.selected = payload
        },
        SET_PREORDINI_CREATE(state, payload) {
            state.create = payload
        },
        SET_PREORDINI_DELETE(state, payload) {
            state.delete = payload
        },
        SET_PREORDINI_EDIT(state, payload) {
            state.edit = payload
        },
        TOGGLE_PREORDINI_CREATE(state) {
            state.create = !state.create
        },
        TOGGLE_PREORDINI_EDIT(state) {
            state.edit = !state.edit
        },
        TOGGLE_PREORDINI_DELETE(state) {
            state.delete = !state.delete
        },
        TOGGLE_PREORDINI_FILTERS_STATUS_INSERITO(state) {
            state.filters.status.inserito = !state.filters.status.inserito
        },
        TOGGLE_PREORDINI_FILTERS_STATUS_ORDINATO(state) {
            state.filters.status.ordinato = !state.filters.status.ordinato
        },
        TOGGLE_PREORDINI_FILTERS_STATUS_ARRIVATO(state) {
            state.filters.status.arrivato = !state.filters.status.arrivato
        },
        TOGGLE_PREORDINI_FILTERS_STATUS_CONSEGNATO(state) {
            state.filters.status.consegnato = !state.filters.status.consegnato
        },
    },
    getters: {
        getPreordini: state => state.list,
        getPreordiniSelected: state => state.selected,
        getPreordiniCreate: state => state.create,
        getPreordiniEdit: state => state.edit,
        getPreordiniDelete: state => state.delete,
        getPreordiniFiltersStatus: state => state.filters.status
    }
}

export default preordini